export default "__VITE_PUBLIC_ASSET__c6f1fe94__"